import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { SeedlingOriginService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SeedlingOriginCreateDto,
  SeedlingOriginDto,
  SeedlingOriginExcelDownloadDto,
  SeedlingOriginUpdateDto,
} from '../proxy/planning/dtos/seedling-origin';
import { SEEDLINGORIGIN_CONFIG, SEEDLINGORIGIN_FIELDS } from './seedling-origin.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-seedling-origin',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SeedlingOriginService, ConfirmationService],
  templateUrl: './seedling-origin.html',
  styleUrl: './seedling-origin.scss',
})
export class SeedlingOrigin extends BaseCrudComponent<
  SeedlingOriginDto,
  SeedlingOriginCreateDto,
  SeedlingOriginUpdateDto,
  SeedlingOriginExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(SeedlingOriginService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('SeedlingOrigin', ids),
  };
  config = SEEDLINGORIGIN_CONFIG;
  fields = SEEDLINGORIGIN_FIELDS;

  protected prepareUpdateDto(data: any, selected: SeedlingOriginDto): SeedlingOriginUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SeedlingOrigin';
  }
}
